import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Privacy(props) {
  useEffect(() => {
    document.title = "BitCash Privacy Policy";
  }, []);

  return (
    <>
      <Header {...props} />
      <div className="wrap-privacy d-flex align-items-center">
        <div className="container py-5">
          <div className="terms_border">
            <div className="d-block mx-auto">
              <h1 className="text-left font-size-40 text-gradient">Privacy Policy</h1>
              <br />
            </div>
            <div className="para">
              <p className="para text-gradient">
                At BitCash, your privacy is fundamental to the way we operate. This Privacy Policy outlines how we collect, use, store, and protect your data while using our platform. We are committed to safeguarding your information in accordance with international standards and best practices.
              </p>
              <br />

              <p className="para text-gradient">1. Transparency at All Times</p>
              <p>
                We are committed to full transparency regarding the data we collect, why we collect it, and how we use it. You will always be informed when your data is collected and have access to the reasons and benefits behind its usage.
              </p>

              <br />
              <p className="para text-gradient">2. Data Minimization & Purpose Limitation</p>
              <p>
                We only collect data that is essential for the operation of our platform—such as identity verification (KYC), transaction processing, and fraud prevention. Your data will never be used for any unrelated purpose without your explicit consent.
              </p>

              <br />
              <p className="para text-gradient">3. Accountability and Compliance</p>
              <p>
                BitCash adheres to all applicable laws and privacy regulations, including GDPR, CCPA, and global financial compliance standards. We conduct regular audits and monitor internal processes to ensure accountability and proper data governance.
              </p>

              <br />
              <p className="para text-gradient">4. User's Rights and Access</p>
              <p>
                You have the right to access, update, correct, or delete your personal data at any time. We also support the right to data portability, data restriction, and objection to automated decisions. You can contact our support team to exercise any of these rights.
              </p>

              <br />
              <p className="para text-gradient">5. Data Security</p>
              <p>
                We employ advanced security measures such as end-to-end encryption, secure storage, and access controls to protect your data from unauthorized access, disclosure, alteration, or destruction. Our systems are regularly tested for vulnerabilities and compliance.
              </p>

              <br />
              <p className="para text-gradient">6. Privacy by Design</p>
              <p>
                Privacy is embedded into every feature and process at BitCash. From account creation to transaction logging, all processes are built with security and privacy as default settings. We take a proactive approach to prevent data misuse and enhance privacy safeguards at every stage.
              </p>

              <br />
              <p>
                If you have any questions about this policy or need to exercise your rights, please contact our Data Privacy Team at <strong>infobitcash2025@gmail.com</strong>.
              </p>

              <br />
              <p>
                By using BitCash, you agree to this Privacy Policy and acknowledge that you understand and accept how we handle your personal data.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
